export default __webpack_public_path__ + "static/media/check_on.4d480c0a.svg";